<medpace-editable-card
    [mode]="mode"
    [title]="title"
    [showTitleAsteriskWhenEditMode]="false"
    [showSwitchModeButton]="showSwitchModeButton"
    class="o-grid"
    [isLoading]="false"
    [formGroup]="formGroup"
>
    <medpace-editable-card-view-mode-content>
        <div class="o-grid">
            @for (noteFormGroup of formGroup.controls.notes.controls; let i = $index; track noteFormGroup) {
                @if (!!noteFormGroup.valueModel.note) {
                    <div [id]="'note-card-element_' + i" class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Note {{ i + 1 }}:</h5>
                                @if (
                                    noteFormGroup.valueModel.modifiedInitials && noteFormGroup.valueModel.modifiedTime
                                ) {
                                    <div class="o-grid__row">
                                        <div class="c-info__block note">
                                            <span class="grey mr-2 note-element-initials">{{
                                                noteFormGroup.valueModel.modifiedInitials || 'Not specified'
                                            }}</span>
                                            <span class="grey note-element-timestamp">{{
                                                noteFormGroup.valueModel.modifiedTime | dateFormat: datetime12 : 'utc'
                                            }}</span>
                                        </div>
                                    </div>
                                }
                                <span class="note-element-content">{{
                                    noteFormGroup.valueModel.note || 'Not specified'
                                }}</span>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <span>{{ 'Not specified' }}</span>
                            </div>
                        </div>
                    </div>
                }
            } @empty {
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <span>There are no notes to be displayed.</span>
                    </div>
                </div>
            }
        </div>
    </medpace-editable-card-view-mode-content>
    <medpace-editable-card-edit-mode-content>
        <div class="o-grid">
            @for (noteFormGroup of formGroup.controls.notes.controls; let i = $index; track noteFormGroup) {
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <div class="w-full">
                            <mds-textarea
                                [label]="'Note ' + (i + 1)"
                                [placeholder]="'Type here...'"
                                [appearance]="'outline'"
                                [id]="'notesCard_' + i"
                                name="notesCard"
                                [autoSize]="true"
                                [cdkAutosizeMinRows]="8"
                                [cdkAutosizeMaxRows]="8"
                                [formCtrl]="noteFormGroup.controls.note"
                            >
                            </mds-textarea>
                        </div>
                    </div>
                    <div class="delete-icon ml-[1.4rem]">
                        <mds-icon-button
                            [icon]="'delete'"
                            (clickEvent)="removeNote(i)"
                            [tooltip]="'Delete'"
                            class="danger outline"
                        ></mds-icon-button>
                    </div>
                </div>
            } @empty {
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <medpace-alert [content]="'To add a note click Add note button'" [appearance]="'highlight'" />
                    </div>
                </div>
            }

            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <mds-button
                            [id]="'add-note'"
                            (clickEvent)="addNote()"
                            color="primary"
                            [variant]="'outline'"
                            label="Add note"
                            width="auto"
                        ></mds-button>
                    </div>
                </div>
            </div>
        </div>
    </medpace-editable-card-edit-mode-content>
</medpace-editable-card>
